import React from 'react'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { ContentfulCTA } from '@toasttab/shared/src/utils/contentfulUtils'
import ButtonTextLink from '@toasttab/shared/src/components/molecules/ButtonTextLink/ButtonTextLink'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import TwoButtons from '@toasttab/shared/src/components/molecules/TwoButtons/TwoButtons'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as LinkedIn } from '@toasttab/shared/src/assets/svg/social/linkedin.svg'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as Twitter } from '@toasttab/shared/src/assets/svg/social/twitter.svg'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as Facebook } from '@toasttab/shared/src/assets/svg/social/facebook.svg'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import DSButton from '@toasttab/shared/src/components/molecules/DSButton/DSButton'

const Components: any = {
  button: DSButton,
  buttonTextLink: ButtonTextLink,
  textLink: TextLink,
  twoButtons: TwoButtons
}

interface ThankYouProps {
  ajaxTyIcon?: any
  ajaxTyHeading?: string
  ajaxTyDescription?: any
  ajaxTyCtas?: any
  ajaxTyShareIconsLabel?: string
  ajaxTyShareIcons?: any
  showThankyou?: boolean
  color?: 'default' | 'inverse'
}

const ThankYou = ({
  ajaxTyIcon,
  ajaxTyHeading,
  ajaxTyDescription,
  ajaxTyCtas,
  ajaxTyShareIconsLabel,
  ajaxTyShareIcons,
  showThankyou = false,
  color = 'default'
}: ThankYouProps) => {
  const pageData = usePageContext()
  const ctas = ajaxTyCtas && ContentfulCTA.buildCtas(ajaxTyCtas)
  const cssClasses = 'text-secondary fill-secondary'

  const renderIcons = () => {
    return ajaxTyShareIcons?.map((icon: any) => {
      let href
      switch (icon) {
        case 'Twitter':
          href = `https://twitter.com/intent/tweet?text=${pageData?.title}&url=${pageData?.url}&via=ToastTab`
          return (
            <a aria-label='Twitter' href={href} key={href}>
              <Twitter className={cssClasses} />
            </a>
          )
        case 'Facebook':
          href = `https://www.facebook.com/sharer/sharer.php?u=${pageData?.url}`
          return (
            <a aria-label='Facebook' href={href} key={href}>
              <Facebook className={cssClasses} />
            </a>
          )
        case 'LinkedIn':
          href = `https://www.linkedin.com/shareArticle?url=${pageData?.url}`
          return (
            <a aria-label='LinkedIn' href={href} key={href}>
              <LinkedIn className={cssClasses} />
            </a>
          )
        default:
          return null
      }
    })
  }

  const colorClass = color === 'inverse' ? 'text-white' : ''

  return (
    <div
      data-testid='ThankYou'
      className={
        showThankyou
          ? 'flex text-center absolute top-0 left-0 right-0 bottom-0 p-6'
          : 'hidden'
      }
    >
      <div className='flex flex-col justify-center items-center text-center flex-grow'>
        {ajaxTyIcon ? (
          <img
            alt={ajaxTyIcon.title}
            className='mb-6 w-12 h-12'
            src={ajaxTyIcon.file.url}
          />
        ) : null}
        {ajaxTyHeading ? (
          <Typography as='h3' classes={`mb-4 ${colorClass}`} variation='h3'>
            {ajaxTyHeading}
          </Typography>
        ) : null}
        {ajaxTyDescription ? (
          <Typography
            allowHtml={false}
            as='div'
            classes={colorClass}
            dangerouslySetHtml={true}
            variation='default'
          >
            {renderRichText(ajaxTyDescription)}
          </Typography>
        ) : null}
      </div>
      <div className='flex-none pb-5 inline-block mx-auto'>
        {ctas?.map((cta: any, index: number) => {
          const Component = Components[cta.typeHandle]
          return Component && <Component key={index} {...cta} />
        })}
      </div>
      <div className='flex flex-row items-center justify-center'>
        {ajaxTyShareIconsLabel ? (
          <Typography as='p' classes='text-secondary' variation='default'>
            {ajaxTyShareIconsLabel}
          </Typography>
        ) : null}
        {ajaxTyShareIcons ? (
          <div className='flex flex-row items-center justify-center'>
            {renderIcons()}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ThankYou
